const infoMessages = {
  amortization: {
    PRICE:
      "Na amortização PRICE, suas parcelas são fixas, você sempre saberá o quanto vai pagar até o fim do contrato. ",
    SAC: "Na amortização SAC, as primeiras parcelas são mais altas no começo e menores no final do contrato."
  },
  term: "Você vai poder antecipar o valor das parcelas a qualquer momento."
}

export { infoMessages }
